import type { IdToFieldSelectionContext, ResolvedFieldSelectionContext } from '#layers/data-model/public';
import { useNuxtApp } from '#app/nuxt';
import { getBlockConfig } from '#layers/block-engine/public';
import { getDisplayTemplateFieldSelection } from '#layers/data-model/public';
import { useWorkspaceSchemaStore } from '#layers/workspace/public';

export function useFieldSelectionContexts() {
	const { findCollectionById, findPrimitiveFieldById, findSingleRelationFieldById } = useWorkspaceSchemaStore();
	const { getBlock } = useNuxtApp().$fieldDisplayBlockResolver;

	const fieldSelectionCtx: ResolvedFieldSelectionContext = {
		getDisplayTemplateFieldSelection: (ast, collection) =>
			getDisplayTemplateFieldSelection(ast, collection, fieldSelectionCtx),
		getCollection: findCollectionById,
		getRelationField: findSingleRelationFieldById,
		resolveDisplayBlock: (displayId) => {
			const block = getBlock(displayId);
			if (block && 'comp' in block) return getBlockConfig(block);
		},
	};

	const idCtx: IdToFieldSelectionContext = {
		findPrimitiveFieldById,
		findSingleRelationFieldById,
	};

	return { fieldSelectionCtx, idCtx };
}
